import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentService } from '../utils/paymentService';

export const usePayment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  const handlePayment = useCallback(async (priceId, planName = '', affiliateKey = null, planAmount = null, currency = 'EUR') => {
    try {
      setLoading(true);
      setError(null);

      if (!PaymentService.isAuthenticated()) {
        const paymentIntent = {
          priceId,
          planName,
          affiliateKey,
          planAmount,
          currency,
          returnUrl: window.location.pathname
        };
        localStorage.setItem('payment_intent', JSON.stringify(paymentIntent));
        
        const message = encodeURIComponent(`Vous devez vous connecter pour souscrire au plan ${planName}`);
        navigate(`/login?message=${message}&redirect=` + encodeURIComponent(window.location.pathname));
        return;
      }

      if (priceId === 'price_1SHqAN87RdvVBQC5lVr2lEq2') {
        navigate('/dashboard');
        return;
      }

      localStorage.setItem(
        'quikr_pending_payment_conversion',
        JSON.stringify({
          planName,
          priceId,
          value: planAmount,
          currency,
          timestamp: Date.now(),
        })
      );
      await PaymentService.initiatePayment(priceId, affiliateKey);
      
    } catch (err) {
      console.error('Erreur lors du paiement:', err);
      setError(err.message || 'Une erreur est survenue lors du paiement');
      localStorage.removeItem('quikr_pending_payment_conversion');
    } finally {
      setLoading(false);
    }
  }, [navigate]);

 
  const processStoredPaymentIntent = useCallback(async () => {
    const storedIntent = localStorage.getItem('payment_intent');
    if (!storedIntent) return false;

    try {
      const { priceId, planName, affiliateKey, planAmount, currency } = JSON.parse(storedIntent);
      localStorage.removeItem('payment_intent');
      
      await handlePayment(priceId, planName, affiliateKey, planAmount, currency);
      return true;
    } catch (err) {
      console.error('Erreur lors du traitement de l\'intention de paiement:', err);
      localStorage.removeItem('payment_intent');
      return false;
    }
  }, [handlePayment]);


  const getButtonText = useCallback((planId) => {
    switch (planId) {
      case 'free':
        return 'Commencer gratuitement';
      case 'basic':
        return 'Essayer Basic';
      case 'clever':
        return 'Choisir Clever';
      case 'premium':
        return 'Passer à Premium';
      case 'custom':
        return 'Contacter les ventes';
      default:
        return 'Choisir ce plan';
    }
  }, []);

  return {
    loading,
    error,
    handlePayment,
    processStoredPaymentIntent,
    getButtonText
  };
};
